(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery */
	const mdBreakpoint = 768;
	const longTransition = 1000;
	const medTransition = 700;





// Open Menu
// -----------------------------------------------------------------------------

	function menuToggle() {
		$(".js-burger-link").click((event) => {
			event.preventDefault();
			$("html").toggleClass("menu-is-open");
		});
	}





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		const lazyLoadInstance = new LazyLoad({
			elements_selector: ".lazy",
		});
	}





// Init Animsition
// -----------------------------------------------------------------------------

	function initAnimsition() {
		$(".animsition").animsition({
			inClass: "fade-in",
			outClass: "fade-out",
			inDuration: medTransition,
			outDuration: longTransition,
			linkElement: ".animsition-link",
			loading: true,
			loadingParentElement: "body",
			loadingClass: "animsition-loading",
			loadingInner: "",
			timeout: true,
			timeoutCountdown: 1000,
			onLoadEvent: true,
			browser: ["animation-duration", "-webkit-animation-duration"],
			overlay: false,
			overlayClass: "animsition-overlay-slide",
			overlayParentElement: "body",
			transition: (url) => { window.location.href = url; },
		});

		$(document).on("click", ".menu-item > a", function (event) {
			const $elem = $(this);
			const url = $elem.attr("href");
			event.preventDefault();
			if (window.matchMedia(`(max-width: ${mdBreakpoint}px)`).matches === true) {
				$("html").toggleClass("menu-is-open");
				$(".animsition").css("visibility", "hidden");
				setTimeout(() => {
					$(".animsition").animsition("out", $elem, url);
				}, 100);
			} else {
				$(".animsition").animsition("out", $elem, url);
			}
		});
	}





// Add numbers in front of method
// -----------------------------------------------------------------------------

	function methodNumber() {
		let counter = 1;
		$(".instructions-wysiwyg p").each(function () {
			if($(this).prev().is("h2")){
				counter = 1;
			};
			$(this).prepend(`<span>${counter}.</span>`);
			counter += 1;
		});
	}
	




// Init Slick
// -----------------------------------------------------------------------------
	
	function initSlick() {
		$(".instagram-slider").slick({
			infinite: false,
			slidesToShow: 6,
			slidesToScroll: 1,
			arrows: false,
			responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 5,
		      }
		    },
		    {
		      breakpoint: 688,
		      settings: {
		        slidesToShow: 4,
		      }
		    },
		    {
		      breakpoint: 488,
		      settings: {
		        slidesToShow: 3,
		      }
		    },
		  ]
		});
	};


// Trigger
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		menuToggle();
		initAnimsition();
		initLazyLoad();
		methodNumber();
		initSlick();
	});

}(jQuery));
